import { AdminSessionResponse } from "@ucorp/contracts";
import { SitesAccessError, type SitesPort } from "./port.js";

export function createHttpSitesPort(apiUrl: string, request: typeof fetch = fetch): SitesPort {
  return {
    async list(session) {
      const response = await request(`${apiUrl.replace(/\/+$/, "")}/auth/admin/me`, {
        headers: { Authorization: `Bearer ${session.accessToken}` },
        cache: "no-store",
        credentials: "omit",
        redirect: "error",
      });
      if (response.status === 401 || response.status === 403) throw new SitesAccessError();
      if (!response.ok) throw new Error("sites_unavailable");
      const context = AdminSessionResponse.parse(await response.json());
      if (context.role !== "provider_operator") throw new SitesAccessError();
      return context;
    },
  };
}
